import { render, staticRenderFns } from "./code.vue?vue&type=template&id=44e072e4&scoped=true&"
import script from "./code.vue?vue&type=script&lang=js&"
export * from "./code.vue?vue&type=script&lang=js&"
import style0 from "./code.vue?vue&type=style&index=0&id=44e072e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e072e4",
  null
  
)

export default component.exports